import "core-js/modules/es.array.push.js";
import { defineComponent as _defineComponent } from 'vue';
import { unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock, createVNode as _createVNode, resolveDirective as _resolveDirective, withDirectives as _withDirectives, createTextVNode as _createTextVNode, isRef as _isRef, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
import _imports_0 from '@/assets/img/workplace/num_03.png';
import _imports_1 from '@/assets/img/workplace/defaul_bac.png';
import _imports_2 from '@/assets/img/workplace/select_success.png';
import _imports_3 from '@/assets/img/workplace/add_icon.png';
const _withScopeId = n => (_pushScopeId("data-v-23127155"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
  class: "person-preview scrollable"
};
const _hoisted_2 = ["onClick"];
const _hoisted_3 = {
  key: 0,
  src: _imports_0,
  alt: ""
};
const _hoisted_4 = {
  key: 1,
  class: "card-body"
};
const _hoisted_5 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  class: "card-bac",
  src: _imports_1,
  alt: ""
}, null, -1));
const _hoisted_6 = ["src"];
const _hoisted_7 = {
  key: 2,
  class: "select_success",
  src: _imports_2,
  alt: ""
};
const _hoisted_8 = {
  key: 0
};
const _hoisted_9 = {
  key: 1
};
const _hoisted_10 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "item-img add-item"
}, [/*#__PURE__*/_createElementVNode("img", {
  class: "add-img",
  src: _imports_3,
  alt: ""
})], -1));
const _hoisted_11 = [_hoisted_10];
import { digitalData, digitalBindItem } from "@/api/knowledgeGraph";
import { ElMessage } from "element-plus";
const __default__ = defineComponent({
  name: "szrDialog"
});
export default /*#__PURE__*/_defineComponent({
  ...__default__,
  props: {
    show: {
      type: Boolean,
      default: false
    },
    digitalId: {
      default: ""
    },
    itemsId: {
      default: ""
    }
  },
  emits: ["close", "refresh"],
  setup(__props, {
    emit
  }) {
    const props = __props;
    const searchOption = reactive({
      pageNum: 1,
      pageSize: 100
    });
    const digitalList = ref([]);
    const loading = ref(false);
    const activeIndex = ref(0);
    const digitalId = ref("");
    const showDialog = computed({
      get: () => props.show,
      set: val => {
        !val && emit("close");
      }
    });
    const handleClose = () => {
      emit("close");
    };
    const tabEvent = (item, index) => {
      activeIndex.value = index;
      digitalId.value = item.id ? item.id : "";
    };
    const fetchData = () => {
      digitalList.value = [];
      digitalData(searchOption, {
        loading
      }).then(({
        data
      }) => {
        digitalList.value = data || [];
        digitalList.value.unshift({
          id: ""
        });
        digitalList.value.map((i, index) => {
          if (props.digitalId == i.id) {
            activeIndex.value = index;
            digitalId.value = i.id ? i.id : "";
          }
        });
      });
    };
    const sumbit = () => {
      bindApi();
    };
    const bindApi = () => {
      let data = {
        itemId: props.itemsId,
        digitalManId: digitalId.value
      };
      digitalBindItem(data).then(res => {
        ElMessage({
          message: "绑定成功",
          type: "success"
        });
        emit("close");
        emit("refresh");
      });
    };
    watchEffect(() => {
      fetchData();
      digitalId.value = props.digitalId;
    });
    return (_ctx, _cache) => {
      const _component_el_col = _resolveComponent("el-col");
      const _component_el_row = _resolveComponent("el-row");
      const _component_el_button = _resolveComponent("el-button");
      const _component_el_dialog = _resolveComponent("el-dialog");
      const _directive_loading = _resolveDirective("loading");
      return _openBlock(), _createElementBlock("div", null, [_createVNode(_component_el_dialog, {
        modelValue: _unref(showDialog),
        "onUpdate:modelValue": _cache[2] || (_cache[2] = $event => _isRef(showDialog) ? showDialog.value = $event : null),
        title: "选择数字人",
        width: "62%",
        class: "resource-dialog dialog-theme",
        "before-close": handleClose,
        "close-on-click-modal": false
      }, {
        footer: _withCtx(() => [_createVNode(_component_el_button, {
          type: "default",
          onClick: _cache[1] || (_cache[1] = $event => showDialog.value = false)
        }, {
          default: _withCtx(() => [_createTextVNode("取消")]),
          _: 1
        }), _createVNode(_component_el_button, {
          type: "primary",
          onClick: sumbit
        }, {
          default: _withCtx(() => [_createTextVNode("确定")]),
          _: 1
        })]),
        default: _withCtx(() => [_withDirectives((_openBlock(), _createElementBlock("div", _hoisted_1, [_createVNode(_component_el_row, {
          gutter: 10
        }, {
          default: _withCtx(() => [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(digitalList), (i, index) => {
            return _openBlock(), _createBlock(_component_el_col, {
              span: 4,
              key: index
            }, {
              default: _withCtx(() => [_createElementVNode("div", {
                onClick: $event => tabEvent(i, index),
                class: "person-item"
              }, [_createElementVNode("div", {
                class: _normalizeClass([_unref(activeIndex) == index ? 'active' : 'none', 'item-img'])
              }, [index == 0 ? (_openBlock(), _createElementBlock("img", _hoisted_3)) : (_openBlock(), _createElementBlock("div", _hoisted_4, [_hoisted_5, _createElementVNode("img", {
                class: "bac-people",
                src: i.digitalMan ? i.digitalMan.coverImageUrl : '',
                alt: ""
              }, null, 8, _hoisted_6)])), _unref(activeIndex) == index ? (_openBlock(), _createElementBlock("img", _hoisted_7)) : _createCommentVNode("", true)], 2), index == 0 ? (_openBlock(), _createElementBlock("span", _hoisted_8, "默认人设")) : (_openBlock(), _createElementBlock("span", _hoisted_9, _toDisplayString(i.digitalManName), 1))], 8, _hoisted_2)]),
              _: 2
            }, 1024);
          }), 128)), _createVNode(_component_el_col, {
            span: 4
          }, {
            default: _withCtx(() => [_createElementVNode("div", {
              onClick: _cache[0] || (_cache[0] = $event => _ctx.$router.push({
                name: 'config',
                query: {
                  itemId: props.itemsId
                }
              })),
              class: "person-item"
            }, _hoisted_11)]),
            _: 1
          })]),
          _: 1
        })])), [[_directive_loading, _unref(loading)]])]),
        _: 1
      }, 8, ["modelValue"])]);
    };
  }
});